export default {
  formId: "UltiproConfiguration",
  formField: {
    domain: {
      name: "domain",
      label: "Ultipro Domain",
      type: "text",
      errorMsg: "Domain is required.",
      invalidMsg: "Domain is invalid",
    },
    username: {
      name: "username",
      label: "Username",
      type: "text",
      errorMsg: "Username is required.",
      invalidMsg: "Username is invalid",
    },
    password: {
      name: "password",
      label: "Password",
      type: "password",
      errorMsg: "Password is required.",
      invalidMsg: "Password is invalid",
    },
    clientId: {
      name: "clientId",
      label: "Client Key",
      type: "text",
      errorMsg: "Client Key is required.",
      invalidMsg: "Client Key is invalid",
    },
  },
};
